import React from 'react';
import { ViewModifierGroupState } from './viewModifierGroupState/ViewModifierGroupState';
import { ViewForm } from './components/ViewForm';
import { ModalWindows } from './components/ModalWindows';

export const ViewModifierGroupsPageV2: React.FC = () => {
	return (
		<ViewModifierGroupState>
			<ViewForm />
			<ModalWindows />
		</ViewModifierGroupState>
	);
};
